<template>
  <div class="execution">
    <basic-container>
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @on-load="getList"
                 @row-update="handleUpdate"
                 @row-save="handleSave"
                 @search-change="searchChange"
                 @row-del="rowDel">

        <template slot-scope="scope" slot="targetType">
          {{ scope.row.targetType === '0' ? '内容' : '评论'}}
        </template>

        <template slot-scope="scope" slot="createdBy">
          {{ scope.row.creator }}
        </template>

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.complaint_category_add">新增</el-button>
        </template>

        <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.complaint_category_up && !scope.row.isActive"
                     icon="el-icon-upload2"
                     size="mini"
                     @click="handleSwitchStatus(scope.row,scope.index)">上架</el-button>
          <el-button type="text"
                     v-if="permissions.complaint_category_down && scope.row.isActive"
                     icon="el-icon-download"
                     size="mini"
                     @click="handleSwitchStatus(scope.row,scope.index)">下架</el-button>
          <el-button type="text"
                     v-if="permissions.complaint_category_edit"
                     icon="el-icon-edit"
                     size="mini"
                     @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button type="text"
                     v-if="permissions.complaint_category_del"
                     icon="el-icon-delete"
                     size="mini"
                     @click="handleDel(scope.row,scope.index)">删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import {addObj, fetchList, putObj} from '@/api/admin/complaintcategory'
  import {tableOption} from '@/const/crud/admin/complaintcategory'
  import {mapGetters} from 'vuex'

  export default {
    name: 'complaint-category',
    data() {
      return {
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10 // 每页显示多少条
        },
        tableLoading: false,
        tableOption: tableOption
      }
    },
    created() {
    },
    mounted: function () {
    },
    computed: {
      ...mapGetters(['permissions'])
    },
    methods: {
      getList(page, params) {
        this.tableLoading = true
        fetchList(Object.assign({
          current: page.currentPage,
          size: page.pageSize
        }, params)).then(response => {
          this.tableData = response.data.data.records
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      /**
       * @title 打开新增窗口
       * @detail 调用crud的handleadd方法即可
       *
       **/
      handleAdd: function () {
        this.$refs.crud.rowAdd()
      },
      handleEdit(row, index) {
        this.$refs.crud.rowEdit(row, index)
      },
      handleDel(row, index) {
        this.$refs.crud.rowDel(row, index)
      },
      handleSwitchStatus (row, index) {
        this.$confirm('是否' + (!row.isActive ? '上架' : '下架') + '?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let params = {
            id: row.id,
            isActive: !row.isActive
          }
          const response = await this.requestWrapper(putObj, params);
          if (!response || response.ok === false) {
            this.$message({
              showClose: true,
              message: response.message || (row.isActive ? '下架' : '上架') + '失败',
              type: 'error',
            });
            return;
          }

          this.getList(this.page)
          this.$message({
            showClose: true,
            message: (row.isActive ? '下架' : '上架') + '成功',
            type: 'success'
          })
        }).catch(function (err) {
        })
      },
      async rowDel (row, index) {
        var _this = this
        this.$confirm('是否确认删除分类词为"' + row.label + '的举报分类?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async function () {
          let params = {
            id: row.id,
            delFlag: '1'
          }
          const response = await _this.requestWrapper(putObj, params);
          if (!response || response.ok === false) {
            _this.$message({
              showClose: true,
              message: response.message || '删除失败',
              type: 'error',
            });
            return;
          }

          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          _this.getList(_this.page)
        }).catch(function (err) {
        })
      },
      /**
       * @title 数据更新
       * @param row 为当前的数据
       * @param index 为当前更新数据的行数
       * @param done 为表单关闭函数
       *
       **/
      async handleUpdate (row, index, done, loading) {
        let params = {
          id: row.id,
          sort: row.sort
        }
        const response = await this.requestWrapper(putObj, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '修改失败',
            type: 'error',
          });
          loading()
          return;
        }

        this.$message({
          showClose: true,
          message: '修改成功',
          type: 'success'
        })
        this.getList(this.page)
        done()
      },
      /**
       * @title 数据添加
       * @param row 为当前的数据
       * @param done 为表单关闭函数
       *
       **/
      async handleSave (row, done, loading) {
        let params = {
          targetType: 1,
          label: row.label.trim(),
          labelEn: row.labelEn.trim(),
          sort: row.sort
        }
        const response = await this.requestWrapper(addObj, params);
        if (!response || response.ok === false) {
          this.$message({
            showClose: true,
            message: response.message || '添加失败',
            type: 'error',
          });
          loading()
          return;
        }

        this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success'
        })
        this.getList(this.page)
        done()
      },
      searchChange(form) {
        this.getList(this.page, form)
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>

